import { type TokenizeResponse } from '../../types/TokenizeResponse';
import { type MessageResponse } from '../../utils/messages/types';
import { InteractionName } from '../../types/InteractionName';
import { panoramaClient } from '../../utils/panoramaClient/panoramaClient';
import { type SqVerificationDetails } from './types';
import { extractSquareTokenizeErrorDetails, mapSquareTokenizeErrorToErrorCode } from './utils';
import { square } from './index';

export async function tokenizeViaSquare(
  sqVerificationDetails?: SqVerificationDetails,
): Promise<MessageResponse<TokenizeResponse>> {
  panoramaClient.transaction(InteractionName.SQUARE_SDK_TOKENIZE).start();
  let result: Awaited<ReturnType<typeof square.api.tokenize>>;
  try {
    result = await square.api.tokenize(sqVerificationDetails);
  } catch (error: unknown) {
    const providerError = extractSquareTokenizeErrorDetails(error);
    return {
      error: {
        errorCode: mapSquareTokenizeErrorToErrorCode(error),
        ...(providerError && { providerError }),
      },
    };
  }
  panoramaClient.transaction(InteractionName.SQUARE_SDK_TOKENIZE).finish();
  return { numberToken: result.numberToken, expiration: result.expiration };
}
